// extracted by mini-css-extract-plugin
module.exports = {"button":"add-module__button___3bhKF","text-button":"add-module__text-button___1XWSf","textButton":"add-module__text-button___1XWSf"};